import { useState } from "react";
import { projectIconColour, projectIconText } from "../lib/projectIcon";

export interface ProjectIconProps {
  projectKey: string;
  /** 24 px in pickers and lists, 32 px in a page head. */
  size?: 24 | 32;
  /** Read-only, closed or archived: the icon at half opacity (the caller still writes the state in words). */
  muted?: boolean;
  /** R3 "later": an uploaded picture. Not offered yet; when set, it shows and the generated tile is the fallback. */
  pictureUrl?: string | null;
  className?: string;
}

/**
 * Batch 18 GRF-47 (ruling R3 A, B18-UX-SPECS §4): every project gets a generated icon — a rounded square in a colour picked
 * from its key, with the key (or its first two characters) in white. The text is decorative: the key and name are always
 * written beside the icon. 24 px in pickers and lists, 32 px in a page head.
 */
export function ProjectIcon({ projectKey, size = 24, muted = false, pictureUrl, className }: ProjectIconProps) {
  const [failed, setFailed] = useState<string | null>(null);
  const classes = ["gf-projicon", size === 32 ? "lg" : "", muted ? "muted" : "", className ?? ""].filter(Boolean).join(" ");
  if (pictureUrl && failed !== pictureUrl) {
    return (
      <span className={`${classes} img`} aria-hidden="true" data-project-icon={projectKey}>
        <img src={pictureUrl} alt="" loading="lazy" onError={() => setFailed(pictureUrl)} />
      </span>
    );
  }
  return (
    <span className={classes} aria-hidden="true" data-project-icon={projectKey} style={{ background: projectIconColour(projectKey) }}>
      {projectIconText(projectKey)}
    </span>
  );
}
